import { fetch } from '@maxtropy/components';
import { PageResponse } from './ggd';
import { Key } from 'react';

export interface EnergyConsumptionAdminList {
  /**
   * 能源介质id
   */
  energyMediumId?: number;
  /**
   * 能源介质名称
   */
  energyMediumName?: string;
}

export interface EnergyConsumptionPlanGetStaffOrgMapping {
  /**
   * 部门id
   */
  ownerOrgId?: string;
  /**
   * 部门名称
   */
  ownerOrgName?: string;
  /**
   * 限制时间选择
   */
  limitTime?: boolean;
  /**
   * 区域
   */
  areaList?: {
    /**
     * 区域id
     */
    id?: number;
    /**
     * 区域编码
     */
    zoneCode?: string;
    /**
     * 区域名称
     */
    zoneName?: string;
  }[];
}

export interface TimeDetailItem {
  startDateTime: string; // 格式: "YYYY-MM-DD HH:MM"
  endDateTime: string; // 格式: "YYYY-MM-DD HH:MM"
}

// 日期时间详情
interface TimeDetailVo {
  date: string; // 格式: "YYYY-MM-DD"
  displayType: number;
  detailList: TimeDetailItem[];
}

// 区域信息
interface AreaInfoVo {
  areaId: number;
  areaName: string;
  timeDetailVoList: TimeDetailVo[];
}

// 所属组织信息
export interface OwnerOrgInfoVo {
  ownerOrgId: string;
  ownerOrgName: string;
  areaInfoVoList: AreaInfoVo[];
}

// 介质信息（根级结构）
export interface MediumInfo {
  mediumId: number;
  mediumName: string;
  ownerOrgInfoVoList: OwnerOrgInfoVo[];
}

export interface DelayEnergyConsumptionRequest {
  page?: number;
  size?: number;
  /**
   * 部门id
   */
  ownerOrgId?: number;
  /**
   * 区域id
   */
  zoneIdList?: number[];
  /**
   * 状态枚举(null代表所有)：0-草稿，1-待审批，2-已批准，3-已拒绝，4-待办
   */
  status?: string | number;
  /**
   * 最后操作人
   */
  userName?: string;
  /**
   * 最后操作时间：开始时间
   */
  startTime?: string | number;
  /**
   * 最后操作时间：结束时间
   */
  endTime?: string | number;
}

export interface DelayEnergyConsumptionResponse {
  /**
   * id
   */
  id?: number;
  /**
   * 申请单号
   */
  code?: string;
  /**
   * 部门id
   */
  ownerOrgId?: string;
  /**
   * 部门名称
   */
  ownerOrgName?: string;
  /**
   * 区域列表
   */
  areaList?: {
    /**
     * 区域id
     */
    id?: number;
    /**
     * 区域编码
     */
    zoneCode?: string;
    /**
     * 区域名称
     */
    zoneName?: string;
  }[];
  /**
   * 审批结果（0草稿、1已拒绝、2已批准、3待审批-一级审批、4待审批-二级审批、5已批准-自动审批）
   */
  approvalResult?: number;
  approvable?: boolean;
  /**
   * 申请人
   */
  applyUserName?: string;
  /**
   * 申请时间
   */
  applyTime?: number;

  /**
   * 时间范围
   */
  timeRange?: string;
  /**
   * 能源介质
   */
  energyMedium?: string;
}

export interface AdminPageRequest {
  /**
   * 部门id
   */
  ownerOrgId?: number[];
  /**
   * 区域id
   */
  areaId?: number[];
  /**
   * 介质id
   */
  energyMediumId?: string | number;
  /**
   * 开始日期 时间戳
   */
  startDate?: string | number;
  /**
   * 结束日期 时间戳
   */
  endDate?: string | number;
  /**
   * 页数
   */
  page?: number;
  /**
   * 每页条数
   */
  size?: number;
}

export interface PlanPageRequest {
  /**
   * 区域id
   */
  zoneIdList?: number[];
  /**
   * 开始日期 时间戳
   */
  startDate?: string | number;
  /**
   * 结束日期 时间戳
   */
  endDate?: string | number;
  /**
   * 页数
   */
  page?: number;
  /**
   * 每页条数
   */
  size?: number;
}

export interface PlanPageResponse {
  /**
   * id
   */
  id?: number;
  /**
   * 申请单号
   */
  code?: string;
  /**
   * 部门id
   */
  ownerOrgId?: string;
  /**
   * 部门名称
   */
  ownerOrgName?: string;
  /**
   * 是否可编辑/删除
   * true可以编辑删除，false不可编辑删除
   */
  editable?: boolean;
  /**
   * 区域id
   */
  zoneId?: number;
  /**
   * 区域编码
   */
  zoneCode?: string;
  /**
   * 区域名称
   */
  zoneName?: string;
  /**
   * 时间范围
   */
  timeRange?: string;
  /**
   * 能源介质
   */
  energyMedium?: string;
  /**
   * 申请人
   */
  applyUserName?: string;
  /**
   * 申请时间
   */
  applyTime?: number;
}
export interface DayDataVO {
  /**
   * 1、用能计划  2、延时用能申请
   */
  type?: number;
  day?: string;
  /**
   * 开始时间
   */
  startDateTime?: string;
  /**
   * 结束时间
   */
  endDateTime?: string;
}

export interface AdminPageResponse {
  /**
   * 部门id
   */
  ownerOrgId?: string;
  /**
   * 部门名称
   */
  ownerOrgName?: string;
  /**
   * 区域id
   */
  areaId?: number;
  /**
   * 区域名称
   */
  areaName?: string;
  /**
   * 第一天
   */
  day1Data?: DayDataVO[];
  /**
   * 第二天
   */
  day2Data?: [];
  /**
   * 第三天
   */
  day3Data?: DayDataVO[];
  /**
   * 第四天
   */
  day4Data?: DayDataVO[];
  /**
   * 第五天
   */
  day5Data?: DayDataVO[];
  /**
   * 第六天
   */
  day6Data?: DayDataVO[];
  /**
   * 第七天
   */
  day7Data?: DayDataVO[];
}

export interface NumOfEachApprovalStatusResponse {
  totalNum: number;
  draftNum: number;
  pendingApprovalNum: number;
  approvedNum: number;
  rejectNum: number;
  todoNum: number;
}
export interface GetStaffDeptPostResponse {
  ownerOrgId?: string;
  ownerOrgName?: string;
}
export interface GetAreaListPostResponse {
  id?: number;
  zoneCode?: string;
  zoneName?: string;
}

export interface DetailListVO {
  /**
   * 区域集合
   */
  areaList?: {
    /**
     * 区域id
     */
    id?: number;
    /**
     * 区域编码
     */
    zoneCode?: string;
    /**
     * 区域名称
     */
    zoneName?: string;
  }[];
  /**
   * 作业人数
   */
  workers?: number;
  /**
   * 作业内容
   */
  content?: string;
  /**
   * 用能类型
   */
  mediumList?: {
    /**
     * 介质id
     */
    id?: number;
    /**
     * 介质名字
     */
    mediumName?: string;
  }[];
  /**
   * 开始时间
   */
  startTime?: number | Date;
  /**
   * 结束时间
   */
  endTime?: number | Date;
  /**
   * 用能时长
   */
  duration?: number;
}

export interface ApprovalDetail {
  /**
   * 审批人
   */
  staffList?: {
    staffId?: number;
    staffName?: string;
    isActualApproval?: boolean;
  }[];
  /**
   * 审批结果（0已驳回、1已通过、2待审批）
   */
  approvalResult?: number;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 审批时间
   */
  approvalTime?: number;
  /**
   * 是否可以审批
   */
  approvable?: boolean;
}
export interface GetDelayEnergyConsumptionDetailPostResponse {
  /**
   * 申请单ID
   */
  id?: number;
  /**
   * 申请单编号
   */
  code?: string;
  /**
   * 部门id
   */
  ownerOrgId?: string;
  /**
   * 部门name
   */
  ownerOrgName?: string;
  /**
   * 是否可编辑删除
   * 自己创建的才可编辑或删除
   */
  admin?: boolean;
  /**
   * 延时用能明细集合
   */
  delayEnergyConsumptionDetailList?: DetailListVO[];
  /**
   * 一级审批明细
   */
  firstApprovalDetail?: ApprovalDetail;
  /**
   * 二级审批明细
   */
  secondApprovalDetail?: ApprovalDetail;
  /**
   * 审批：true 可审批，false 不可审批
   */
  approvable?: boolean;
  /**
   * 审批层级：1一级审批、2二级审批，3已审批完(全部已同意以及拒绝)
   */
  level?: number;
  /**
   * 抄送人
   */
  ccStaffIdList?: {
    /**
     * 员工ID
     */
    staffId?: number;
    /**
     * 员工名称
     */
    staffName?: string;
  }[];
}

export interface ApprovalDelayEnergyConsumption {
  id: number;
  // 0一级审批、1二级审批
  level: number;
  approvalDetail: {
    // 审批结果（0同意、1拒绝）
    approvalResult: number;
    remark: string;
  };
}

export interface UpdateDelayEnergyConsumptionPostRequest {
  /**
   * 延时用能计划id
   */
  id?: string | number;
  /**
   * 部门id
   */
  ownerOrgId?: string;
  /**
   * 部门名称
   */
  ownerOrgName?: string;
  /**
   * type:0保存草稿，1提交申请
   */
  type?: string | number;
  /**
   * 延时用能明细集合
   */
  delayEnergyConsumptionDetailList?: {
    /**
     * 区域id集合
     */
    areaIdList: number[];
    /**
     * 作业人数
     */
    workers: number;
    /**
     * 作业内容
     */
    content?: string;
    /**
     * 用能类型
     */
    mediumIdList: number[];
    /**
     * 开始时间
     */
    startTime: number;
    /**
     * 结束时间
     */
    endTime: number;
    /**
     * 用能时长
     */
    duration: number;
  }[];
}

export interface GetAdminDetailRequest {
  /**
   * 部门id
   */
  ownerOrgId?: string;
  /**
   * 区域id
   */
  areaId?: string | number;
  /**
   * 介质id
   */
  energyMediumId?: string | number;
  /**
   * 天
   */
  day?: string | number;
}

export interface GetAdminDetailResponse {
  /**
   * 部门id
   */
  ownerOrgId?: string;
  /**
   * 部门名称
   */
  ownerOrgName?: string;
  /**
   * 区域id
   */
  areaId?: number;
  /**
   * 区域名称
   */
  areaName?: string;
  delayEnergyUseDuration?: number;
  energyUseDuration?: number;
  /**
   * 用能计划和延时用能计划
   */
  planList?: {
    /**
     * 1、用能计划  2、延时用能申请
     */
    type?: number;
    day?: string;
    /**
     * 开始时间
     */
    startDateTime?: string;
    /**
     * 结束时间
     */
    endDateTime?: string;
  }[];
}

export interface PlanOfMediumListVO {
  /**
   * 介质id
   */
  mediumId?: number;
  /**
   * 介质name
   */
  mediumName?: string;
  /**
   * 部门用能信息
   */
  ownerOrgInfoVoList?: {
    /**
     * 组织id（ 部门Id）
     */
    ownerOrgId?: string;
    /**
     * 组织名称（部门名称）
     */
    ownerOrgName?: string;
    /**
     * 区域信息
     */
    areaInfoVoList?: {
      /**
       * 区域id
       */
      areaId?: number;
      /**
       * 区域名称
       */
      areaName?: string;
      /**
       * 用能申请时间段集合
       */
      timeDetailVoList?: {
        /**
         * 日期
         */
        date?: string;
        /**
         * 展示类型（0:半点展示；1:整点展示）
         */
        displayType?: number;
        /**
         * 时间段详情
         */
        detailList?: {
          /**
           * 开始时间（yyyy-MM-dd HH:mm:ss）
           */
          startDateTime?: null;
          /**
           * 结束时间（yyyy-MM-dd HH:mm:ss）
           */
          endDateTime?: null;
        }[];
      }[];
    }[];
  }[];
}

export interface PlanDetailResponse {
  /**
   * id
   */
  id?: number;
  /**
   * 各介质用能计划
   */
  energyConsumptionPlanOfMediumList?: PlanOfMediumListVO[];
}

export function getEnergyConsumptionAdminList(): Promise<{ list: EnergyConsumptionAdminList[] }> {
  return fetch(
    `/api/v2/h5/energy/plan/energy-medium/list`,
    {
      method: 'POST',
    },
    true
  );
}

export function getStaffOrgMapping(): Promise<EnergyConsumptionPlanGetStaffOrgMapping> {
  return fetch(
    `/api/v2/h5/energy/plan/getStaffOrgMapping`,
    // `/api/v2/energy/consumption/plan/getStaffOrgMapping`,
    {
      method: 'POST',
    },
    true
  );
}

export function addEnergyPlan(params: { energyConsumptionPlanOfMediumList: MediumInfo[] }) {
  return fetch(
    // `/api/v2/energy/consumption/plan/add`,
    `/api/v2/h5/energy/plan/add`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function updateEnergyPlan(params: { id?: number; energyConsumptionPlanOfMediumList: MediumInfo[] }) {
  return fetch(
    `/api/v2/h5/energy/plan/update`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function getUsedTime(params: { id?: number; energyConsumptionPlanOfMediumList: MediumInfo[] }) {
  return fetch(
    `/api/v2/h5/energy/plan/getUsedTime`,
    // `/api/v2/energy/consumption/plan/getUsedTime`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function getDelayEnergyConsumptionPage(
  params: DelayEnergyConsumptionRequest
): Promise<PageResponse<DelayEnergyConsumptionResponse>> {
  return fetch(
    `/api/v2/h5/energy/plan/getDelayEnergyConsumptionPage`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function getNumOfEachApprovalStatus(
  params: DelayEnergyConsumptionRequest
): Promise<NumOfEachApprovalStatusResponse> {
  return fetch(
    `/api/v2/h5/energy/plan/getNumOfEachApprovalStatus`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function getStaffDept(): Promise<{ list: GetStaffDeptPostResponse[] }> {
  return fetch(
    `/api/v2/h5/energy/plan/getStaffDept`,
    // `/api/v2/energy/consumption/plan/getStaffDept`,
    {
      method: 'POST',
    },
    true
  );
}
export function getAreaList(id: Key): Promise<{ list: GetAreaListPostResponse[] }> {
  return fetch(
    `/api/v2/h5/energy/plan/getAreaList`,
    // `/api/v2/energy/consumption/plan/getAreaList`,
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}

export function getAreaList2(ids: Key[]): Promise<{ list: GetAreaListPostResponse[] }> {
  return fetch(
    `/api/v2/h5/energy/plan/getAreaListByMcids`,
    // `/api/v2/energy/consumption/plan/getAreaList2`,
    {
      method: 'POST',
      body: JSON.stringify({ ids }),
    },
    true
  );
}

export function getDelayEnergyConsumptionDetail(id: Key): Promise<GetDelayEnergyConsumptionDetailPostResponse> {
  return fetch(
    `/api/v2/h5/energy/plan/getDelayEnergyConsumptionDetail`,
    // `/api/v2/energy/consumption/plan/getDelayEnergyConsumptionDetail`,
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}

export function deleteDelayEnergyConsumption(id: Key) {
  return fetch(
    `/api/v2/h5/energy/plan/deleteDelayEnergyConsumption`,
    // `/api/v2/energy/consumption/plan/deleteDelayEnergyConsumption`,
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}
export function resubmitApproval(id: Key) {
  return fetch(
    `/api/v2/h5/energy/plan/resubmit`,
    // `/api/v2/energy/consumption/plan/resubmit`,
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}

export function revokeApproval(id: Key) {
  return fetch(
    `/api/v2/h5/energy/plan/revoke`,
    // `/api/v2/energy/consumption/plan/revoke`,
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}
export function approvalDelayEnergyConsumption(params: ApprovalDelayEnergyConsumption) {
  return fetch(
    `/api/v2/h5/energy/plan/approvalDelayEnergyConsumption`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}
export function updateDelayEnergyConsumption(params: UpdateDelayEnergyConsumptionPostRequest) {
  return fetch(
    `/api/v2/h5/energy/plan/updateDelayEnergyConsumption`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}
export function addDelayEnergyConsumption(params: UpdateDelayEnergyConsumptionPostRequest) {
  return fetch(
    `/api/v2/h5/energy/plan/addDelayEnergyConsumption`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}
export function getAdminPageList(params: AdminPageRequest): Promise<PageResponse<AdminPageResponse>> {
  return fetch(
    `/api/v2/h5/energy/plan/manage/page`,
    // `/api/v2/energy/consumption/admin/page`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function getAdminDetail(params: GetAdminDetailRequest): Promise<GetAdminDetailResponse> {
  return fetch(
    `/api/v2/h5/energy/plan/manage/detail`,
    // `/api/v2/energy/consumption/admin/detail`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function getPlanPage(params: PlanPageRequest): Promise<PageResponse<PlanPageResponse>> {
  return fetch(
    `/api/v2/h5/energy/plan/page`,
    // `/api/v2/energy/consumption/plan/page`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}
export function getPlanDetail(params: { id: string }): Promise<PlanDetailResponse> {
  return fetch(
    `/api/v2/h5/energy/plan/detail`,
    // `/api/v2/energy/consumption/plan/detail`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}
export function deletePlan(id: string) {
  return fetch(
    `/api/v2/h5/energy/plan/delete`,
    // `/api/v2/energy/consumption/plan/delete`,
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}

export function getStaffPermission() {
  return fetch(
    `/api/v2/platform-public/staff/permission`,
    {
      method: 'POST',
    },
    true
  );
}

// 批量审批接口
export interface OneKeyApprovalRequest {
  ids: number[];
  approvalType: number; // 0同意、1拒绝
}

export function oneKeyApproval(params: OneKeyApprovalRequest) {
  return fetch(
    // `http://10.50.16.221:40001/mock/487/api/v2/h5/energy/plan/oneKeyApproval`,
    `/api/v2/h5/energy/plan/oneKeyApproval`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

// 催办接口
export function encourageCompletion(id: number) {
  return fetch(
    `/api/v2/h5/energy/plan/encourageCompletion`,
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}
